import i18n from '@dms/i18n';

import {useVehicleFormContext} from '../hooks/useVehicleFormContext';
import {Field} from './primitives/Field';

export function ServiceBookStateChips() {
  const {catalogueApi} = useVehicleFormContext();

  return (
    <Field
      type="chips"
      name="serviceBookState"
      label={i18n.t('entity.vehicle.labels.serviceBookStateLabel')}
      options={catalogueApi?.serviceBookStateOptions ?? []}
      isDeselectable
    />
  );
}
